module.exports = __webpack_public_path__ + "img/LOGO-TCOIN.bd5d6c60.png";